"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.create = create;
exports.default = void 0;
var _isAbsent = _interopRequireDefault(require("./util/isAbsent"));
var _isSchema = _interopRequireDefault(require("./util/isSchema"));
var _printValue = _interopRequireDefault(require("./util/printValue"));
var _locale = require("./locale");
var _runTests = _interopRequireDefault(require("./util/runTests"));
var _ValidationError = _interopRequireDefault(require("./ValidationError"));
var _schema = _interopRequireDefault(require("./schema"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function create(type) {
  return new ArraySchema(type);
}
var ArraySchema = exports.default = /*#__PURE__*/function (_BaseSchema) {
  function ArraySchema(type) {
    var _this;
    _classCallCheck(this, ArraySchema);
    _this = _callSuper(this, ArraySchema, [{
      type: 'array'
    }]); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    _this.innerType = void 0;
    _this.innerType = type;
    _this.withMutation(function () {
      _this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });
    return _this;
  }
  _inherits(ArraySchema, _BaseSchema);
  return _createClass(ArraySchema, [{
    key: "_typeCheck",
    value: function _typeCheck(v) {
      return Array.isArray(v);
    }
  }, {
    key: "_subType",
    get: function get() {
      return this.innerType;
    }
  }, {
    key: "_cast",
    value: function _cast(_value, _opts) {
      var _this2 = this;
      var value = _superPropGet(ArraySchema, "_cast", this, 3)([_value, _opts]); //should ignore nulls here

      if (!this._typeCheck(value) || !this.innerType) return value;
      var isChanged = false;
      var castArray = value.map(function (v, idx) {
        var castElement = _this2.innerType.cast(v, _extends({}, _opts, {
          path: "".concat(_opts.path || '', "[").concat(idx, "]")
        }));
        if (castElement !== v) {
          isChanged = true;
        }
        return castElement;
      });
      return isChanged ? castArray : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this3 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var _options$abortEarly, _options$recursive;
      var errors = [];
      var sync = options.sync;
      var path = options.path;
      var innerType = this.innerType;
      var endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
      var recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
      var originalValue = options.originalValue != null ? options.originalValue : _value;
      _superPropGet(ArraySchema, "_validate", this, 3)([_value, options, function (err, value) {
        if (err) {
          if (!_ValidationError.default.isError(err) || endEarly) {
            return void callback(err, value);
          }
          errors.push(err);
        }
        if (!recursive || !innerType || !_this3._typeCheck(value)) {
          callback(errors[0] || null, value);
          return;
        }
        originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

        var tests = new Array(value.length);
        var _loop = function _loop() {
          var item = value[idx];
          var path = "".concat(options.path || '', "[").concat(idx, "]"); // object._validate note for isStrict explanation

          var innerOptions = _extends({}, options, {
            path: path,
            strict: true,
            parent: value,
            index: idx,
            originalValue: originalValue[idx]
          });
          tests[idx] = function (_, cb) {
            return innerType.validate(item, innerOptions, cb);
          };
        };
        for (var idx = 0; idx < value.length; idx++) {
          _loop();
        }
        (0, _runTests.default)({
          sync: sync,
          path: path,
          value: value,
          errors: errors,
          endEarly: endEarly,
          tests: tests
        }, callback);
      }]);
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      var next = _superPropGet(ArraySchema, "clone", this, 3)([spec]);
      next.innerType = this.innerType;
      return next;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      var next = _superPropGet(ArraySchema, "concat", this, 3)([schema]);
      next.innerType = this.innerType;
      if (schema.innerType) next.innerType = next.innerType ?
      // @ts-expect-error Lazy doesn't have concat()
      next.innerType.concat(schema.innerType) : schema.innerType;
      return next;
    }
  }, {
    key: "of",
    value: function of(schema) {
      // FIXME: this should return a new instance of array without the default to be
      var next = this.clone();
      if (!(0, _isSchema.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, _printValue.default)(schema)); // FIXME(ts):

      next.innerType = schema;
      return next;
    }
  }, {
    key: "length",
    value: function length(_length) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _locale.array.length;
      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length
        },
        test: function test(value) {
          return (0, _isAbsent.default)(value) || value.length === this.resolve(_length);
        }
      });
    }
  }, {
    key: "min",
    value: function min(_min, message) {
      message = message || _locale.array.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        // FIXME(ts): Array<typeof T>
        test: function test(value) {
          return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max, message) {
      message = message || _locale.array.max;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max
        },
        test: function test(value) {
          return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
        }
      });
    }
  }, {
    key: "ensure",
    value: function ensure() {
      var _this4 = this;
      return this.default(function () {
        return [];
      }).transform(function (val, original) {
        // We don't want to return `null` for nullable schema
        if (_this4._typeCheck(val)) return val;
        return original == null ? [] : [].concat(original);
      });
    }
  }, {
    key: "compact",
    value: function compact(rejector) {
      var reject = !rejector ? function (v) {
        return !!v;
      } : function (v, i, a) {
        return !rejector(v, i, a);
      };
      return this.transform(function (values) {
        return values != null ? values.filter(reject) : values;
      });
    }
  }, {
    key: "describe",
    value: function describe() {
      var base = _superPropGet(ArraySchema, "describe", this, 3)([]);
      if (this.innerType) base.innerType = this.innerType.describe();
      return base;
    }
  }, {
    key: "nullable",
    value: function nullable() {
      var isNullable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return _superPropGet(ArraySchema, "nullable", this, 3)([isNullable]);
    }
  }, {
    key: "defined",
    value: function defined() {
      return _superPropGet(ArraySchema, "defined", this, 3)([]);
    }
  }, {
    key: "required",
    value: function required(msg) {
      return _superPropGet(ArraySchema, "required", this, 3)([msg]);
    }
  }]);
}(_schema.default);
create.prototype = ArraySchema.prototype; //
// Interfaces
//